const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuariIdPerfil = async (id : string, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/usuaris/${id}/perfil`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (!response.ok) {
            alert(await response.text());
        }
        return response.json();

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
